import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";

interface EmptyClientListProps {
  onConnectClient: () => void;
}

const EmptyClientList = ({ onConnectClient }: EmptyClientListProps) => {
  return (
    <Card className="col-span-full bg-white backdrop-blur-sm">
      <CardContent className="pt-6">
        <p className="text-center text-muted-foreground">You don't have any clients assigned yet.</p>
        <div className="flex justify-center mt-4">
          <Button 
            onClick={onConnectClient} 
            variant="outline"
            className="bg-white hover:bg-[#E8F0F8] transition-all duration-300"
          >
            <Users className="mr-2 h-4 w-4" />
            Connect with a Client
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyClientList;
